export const KOFI_PAGE_ID = "J2I722159I";
export const KOFI_BUTTON_COLOR = "#72a4f2";
export const KOFI_WIDGET_SCRIPT_URL = "https://storage.ko-fi.com/cdn/widget/Widget_2.js";
export const KOFI_BUTTON_CONTAINER_MARKER = "<div class=btn-container>";
